var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 125.66 45.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b4942f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.7,3.23c-7.84,0-14.21,6.38-14.21,14.21s6.38,14.21,14.21,14.21,14.21-6.37,14.21-14.21-6.38-14.21-14.21-14.21ZM71.72,17.44c0,4.97-4.05,9.02-9.02,9.02s-9.02-4.05-9.02-9.02,4.05-9.02,9.02-9.02,9.02,4.05,9.02,9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.7,13.88c-1.97,0-3.56,1.59-3.56,3.56s1.59,3.56,3.56,3.56,3.56-1.59,3.56-3.56-1.59-3.56-3.56-3.56Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.13,
    y: 38.94,
    width: 125.66,
    height: 6.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductGold);
export default __webpack_public_path__ + "static/media/product-gold.b448f418fb3d4a8af7ac9de89b74bd16.svg";
export { ForwardRef as ReactComponent };